<app-header></app-header>
<app-set-meta title="パスワード再設定｜Forbes CAREER"></app-set-meta>
<div class="wrapper">
  <div class="pc_contents_wrapper">
    <h1>パスワード再設定</h1>
    <div class="form_wrapper">
      <form [formGroup]="form" *ngIf="!codeError && !updateSuccess">
        <div class="form-group">
          <input placeholder="新しいパスワード" type="password" formControlName="password" class="form-control" />
        </div>
        <button type="button" (click)="updatePassword()" class="btn btn-primary btn-block">
          新しいパスワードを設定する
        </button>
        <div *ngIf="updateError">
          パスワードの変更に失敗しました
        </div>
      </form>

      <div *ngIf="codeError">
        無効なURLです
      </div>

      <div *ngIf="updateSuccess">
        パスワードを変更しました
      </div>
    </div>
  </div>
  <app-footer></app-footer>
</div>
